import { CustomOnboarding } from '@services/Marpple/client/widgets/CreatorDesign/CustomOnboarding.page.ts';
import { CustomOnboardingMo } from '@services/Marpple/client/widgets/CreatorDesign/CustomOnboardingMo.page.ts';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { OMPCoreUtilF } from '../../../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { SimpleModalMuiF } from '../../../../../SimpleModal/F/Mui/module/SimpleModalMuiF.js';
import { UtilF } from '../../../../../Util/F/Function/module/UtilF.js';

const CUSTOM_IMGS = [
  '//s3.marpple.co/files/u_5229077/2025/7/original/f47418d73bb9d9d045b569b30b7b83ad881c2f901.png',
  '//s3.marpple.co/files/u_5229077/2025/7/original/450a0eb8496ae24205f6d6f67450afbda1224a632.png',
  '//s3.marpple.co/files/u_5229077/2025/7/original/df719436a29f749fd0c4e7a93b259c99697a66ae3.png',
  '//s3.marpple.co/files/u_5229077/2025/7/original/96612bacd4684d9659c6e10d0a076be998e2baeb4.png',
  '//s3.marpple.co/files/u_5229077/2025/7/original/517f4e73091dc7f8047598601e1e24d8707c47545.png',
];
const CUSTOM_IMGS_EN = [
  '//s3.marpple.co/files/u_193535/2025/7/original/60a6b2eec70a3e9309a81c48aea1654b21ed1cde5.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/b519e38589e1e1cc21ee5bb5cae415aad81024a64.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/7cff8d3e26849101aaf43b58a7aa307512cefa253.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/827cdc27665ae63d8aa8a77f09523d2c31e748452.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/2d00ee17ff9b437c2f36cfe19f6478eb0021cb351.png',
];
const CUSTOM_IMGS_JP = [
  '//s3.marpple.co/files/u_193535/2025/7/original/65e5fe432bc644b1e2d2bc75b956c6a4afc1f6d55.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/590a2eee7f840854f67ffd6b1795f2a4c1b034ce4.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/67afbef1945a8e26305ec90085aab950e9bb33943.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/aacbb888fe379fc7e1489c2bb7922f7a1ab43e3d2.png',
  '//s3.marpple.co/files/u_193535/2025/7/original/8a9c243b17c621c5135cad349acc4b2179b1715e1.png',
];

const ONBOARDING_IMG_KR =
  '//s3.marpple.co/files/u_5229077/2025/7/original/20075376be02f92b61d3933e6d02cda0128be37a1.png';
const ONBOARDGIN_IMG_EN =
  '//s3.marpple.co/files/u_193535/2025/7/original/39588a212fee9dd2fa6da4bb4659bb440df6e6011.png';
const ONBOARDGIN_IMG_JP =
  '//s3.marpple.co/files/u_193535/2025/7/original/ec649cc5db2609790c47a66715eb37c0a88fdcc01.png';

export const openFrame = () => {
  return new Promise((resolve) => {
    MuiF.openFrame(SimpleModalMuiF.frame, async (f, p, [t]) => {
      t.template = async () => {
        return !UtilF.isLegacyMobile()
          ? new CustomOnboarding({
              img_src:
                T.lang === 'en' ? ONBOARDGIN_IMG_EN : T.lang === 'jp' ? ONBOARDGIN_IMG_JP : ONBOARDING_IMG_KR,
            }).toHtmlSSR()
          : new CustomOnboardingMo({
              list: T.lang === 'en' ? CUSTOM_IMGS_EN : T.lang === 'jp' ? CUSTOM_IMGS_JP : CUSTOM_IMGS,
            }).toHtmlSSR();
      };
      t.appended = () => {
        !UtilF.isLegacyMobile()
          ? OMPCoreUtilF.hydrationRune(CustomOnboarding)
          : OMPCoreUtilF.hydrationRune(CustomOnboardingMo);
      };
    });
  });
};
